export default {
    organizations: 'Grupos de trabajo',
    events: 'Eventos',
    projects: 'Proyectos',
    invitations: 'Invitaciones',
    notifications: 'Notificaciones',
    settings: 'Mis ajustes',
}
